/** Sdílené React Query klíče submodulu Schemas (napříč okny placeholderů i subkategorií). */

/**
 * Klíč ListPage configu placeholderů — zároveň prefix React Query klíčů seznamu
 * (`[PLACEHOLDER_LIST_KEY, 'list' | 'stats', …]`). Slouží k invalidaci seznamu po uložení detailu.
 */
export const PLACEHOLDER_LIST_KEY = 'venua-planner.placeholders';

/** Klíč ListPage configu subkategorií placeholderů — prefix pro invalidaci seznamu subkategorií. */
export const PLACEHOLDER_SUBCATEGORY_LIST_KEY = 'venua-planner.placeholder-subcategories';
